export default __webpack_public_path__ + "static/media/bg-pricing-card.8fff9c6a.jpg";